import { createMarketplaceHttpClient } from "../marketplaceHttpClient";

// Catalogue public : pas de JWT requis (comportement inchangé).
const api = createMarketplaceHttpClient({ authenticated: false });

export default api;
